import { buildStaffMenu } from "./staffMenu"
// Also available for AE-specific tweaks: overrideByKey, removeByKey, addItems from "./helpers"

/**
 * Apollonian Experience role menu — cloned from the shared staff base.
 *
 * Currently mirrors the staff base exactly. To add AE-specific overrides
 * without affecting other roles, edit only this file. Example:
 *
 *   const menu = buildStaffMenu()
 *   return removeByKey(menu, "leave-request")
 */
export const buildAeMenu = () => buildStaffMenu()
